import {CashRegisterPrint} from '@app/domain/cash-register-print';
import {EscPosOrder} from '@app/domain/esc-pos-order';
import {EscPosOrderTypeEnum} from '@app/enums/esc-pos-order-type.enum';

export function hasCashTipBreakdown(data: CashRegisterPrint): boolean {
    return data.versionDesglosePropinas >= 2 && Array.isArray(data.otrosIngresosSinPropinas);
}

/** A decomposition of amounts already in the drawer; this never adds anything to the cash balance. */
export function cashTipPrintOrders(data: CashRegisterPrint, paperWidth: number): EscPosOrder[] {
    if (!hasCashTipBreakdown(data)) { return []; }
    const columns = paperWidth === 58 ? 31 : 48;
    const lines: EscPosOrder[] = [];
    const add = (value: unknown, bold = false) => {
        const clean = String(value ?? '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim();
        for (let start = 0; start < clean.length; start += columns) {
            lines.push({type: EscPosOrderTypeEnum.TEXT, text: {
                value: clean.slice(start, start + columns), lineBreak: true, style: {bold}
            }});
        }
    };
    add('-'.repeat(columns));
    add(`PROPINAS DEL TURNO (${data.moneda})`, true);
    add(`Total propinas: ${data.totalPropinas || '0.00'}`, true);
    (data.montosPagosPropinas || []).forEach(p => add(`${p.metodo}: ${p.monto}`));
    if (data.detallado) {
        (data.propinasDetalle || []).forEach(t => {
            add(`${t.hora || ''} ${t.comprobante || ''}`, true);
            add(t.responsable || 'Sin asignar');
            add(`${t.metodoPago || 'Sin método'}: ${t.pago || '-'}`);
            add(`Importe: ${t.monto}`);
            if (t.pendienteConciliacion) { add('Por conciliar'); }
        });
    }
    if (data.propinasPendientesConciliacion) {
        add(`Por conciliar: ${data.propinasPendientesConciliacion} movimiento(s).`);
    }
    add('Importes ya incluidos en ingresos y efectivo de caja. No sumar nuevamente.');
    add('-'.repeat(columns));
    return lines;
}
